import { HttpParams } from '@angular/common/http';

export function getLazyLoadingParams(
  search: string = '',
  resultsPerPage: number = 20,
  page: number = 0,
) {
  let params = new HttpParams();
  params = params.append('page', page.toString());
  params = params.append('per_page', resultsPerPage.toString());
  params = params.append('search', search);
  return params;
}
